import React from "react";
import "./reviews.css";
function Reviews(){
    return( 
        <>
    <div className="container p-0">
        <div className="review-header fade-in-top" >
          <h1>Check Our Works With <br/>Real Results</h1>
        </div>
    
    
    
        <div className="container ">
          <div className="row g-4">
            {/* <!-- Review Card 1 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Outstanding Web Development Services</div>
                <div className="review-text">
                  "CodeQlik Technologies delivered an exceptional website for our business. The design is sleek, and the
                  functionality is seamless. Their team is professional and attentive to detail."
                </div>
                <div className="review-author">Kiran Kumar</div>
                <div className="review-role">On Stop Solution</div>
              </div>
            </div>
    
            {/* <!-- Review Card 2 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Supportive Work Environment</div>
                <div className="review-text">
                  "CodeQlik Technologies is a great place to work. The management is approachable, and the team is
                  collaborative. They invest in employees' growth and provide opportunities to upskill."
                </div>
                <div className="review-author">S. Thompson</div>
                <div className="review-role">Turner's Tech Solutions</div>
              </div>
            </div>
    
            {/* <!-- Review Card 3 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Exceptional Customer Support</div>
                <div className="review-text">
                  "The team at CodeQlik Technologies is always available to address any concerns. They provide excellent
                  post-project support, ensuring everything runs smoothly."
                </div>
                <div className="review-author">David Rodriguez</div>
                <div className="review-role">Thompson & Co. Real Estate</div>
              </div>
            </div>
    
            {/* <!-- Review Card 4 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Exciting Projects and Learning Opportunities</div>
                <div className="review-text">
                  "Working here has been a rewarding experience. The projects are challenging yet fulfilling, and the
                  company encourages innovation."
                </div>
                <div className="review-author">William Thompson</div>
                <div className="review-role">Atlanta, Georgia</div>
              </div>
            </div>
            {/* <!-- Review Card 5 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Top-notch IT Solutions</div>
                <div className="review-text">
                  "We partnered with CodeQlik Technologies for a custom software project. Their expertise and innovative
                  approach resulted in a product that exceeded our expectations. Highly recommend!"
                </div>
                <div className="review-author">Ryan Martinez</div>
                <div className="review-role">COOPER'S CAR REPAIR SHOP</div>
              </div>
            </div>
    
            {/* <!-- Review Card 6 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Professional and Growth-Oriented</div>
                <div className="review-text">
                  "CodeQlik Technologies values its employees and provides a healthy work-life balance. I’ve grown
                  professionally since joining this company."
                </div>
                <div className="review-author">S. Thompson</div>
                <div className="review-role">RAMIREZ FITNESS STUDIO</div>
              </div>
            </div>
    
            {/* <!-- Review Card 7 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Great Experience Overall</div>
                <div className="review-text">
                  "CodeQlik Technologies built a mobile app for us that is both user-friendly and feature-rich. The team
                  worked hard to meet our tight deadlines without compromising quality."
                </div>
                <div className="review-author">S. Thompson</div>
                <div className="review-role">CARTER'S CAFÉ</div>
              </div>
            </div>
            {/* <!-- Review Card 8 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Great Culture and Leadership</div>
                <div className="review-text">
                  "The leadership at CodeQlik Technologies is visionary and supportive. They ensure that employees feel
                  valued and motivated."
                </div>
                <div className="review-author">Benjamin Davis</div>
                <div className="review-role">BENNETT'S BAKERY</div>
              </div>
            </div>
            {/* <!-- Review Card 9 --> */}
            <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Innovative Solutions for Complex Needs</div>
                <div className="review-text">
                  "CodeQlik Technologies transformed our outdated system into a modern, efficient platform. Their innovative
                  solutions have made a huge difference in our operations."
                </div>
                <div className="review-author">David Rodriguez</div>
                <div className="review-role">Thompson & Co. Real Estate</div>
              </div>
            </div>
    
            {/* <!-- Review Card 10 --> */}
            <div className="col-md-6 col-lg-6"data-aos="fade-up" data-aos-delay="200">
              <div className="review-card">
                <div className="review-stars">
                  ★ ★ ★ ★ ★
                </div>
                <div className="review-title">Perfect Place for IT Enthusiasts</div>
                <div className="review-text">
                  "If you're passionate about IT and want to work in an environment that fosters creativity and excellence,
                  CodeQlik Technologies is the perfect place."
                </div>
                <div className="review-author">Benjamin Davis</div>
                <div className="review-role">BENNETT'S BAKERY</div>
              </div>
            </div>
          </div>
        </div>
    
      </div>
    
        
        
        </>
    
)
}

export default Reviews